<template>
    <div class="high-tech-table-container">
        <div class="table-wrapper">
            <table>
                <!-- 表头 -->
                <thead>
                    <tr>
                        <th>地址</th>
                        <th>温度</th>
                        <th>湿度</th>
                    </tr>
                </thead>
                <!-- 表格数据 -->
                <tbody @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                    <tr v-for="(item, index) in data" :key="index">
                        <td>{{ item.address }}</td>
                        <td>{{ item.temperature }}°C</td>
                        <td>{{ item.humidity }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 表格数据
            tableData: [
                { address: "病房楼2层", temperature: 25, humidity: 60 },
                { address: "病房楼7层", temperature: 26, humidity: 65 },
                { address: "综合楼2层", temperature: 24, humidity: 62 },
                { address: "综合楼8层", temperature: 23, humidity: 58 },
                { address: "门诊楼1层", temperature: 22, humidity: 55 },
                { address: "门诊楼3层", temperature: 21, humidity: 50 },
                { address: "杏林苑2层", temperature: 20, humidity: 48 },
            ],
            startValue: 0,
            endValue: 5,
            data: null
        };
    },
    computed: {
    },
    methods: {
        // 鼠标移入停止
        handleMouseEnter() {
            clearInterval(this.timerId);
        },
        // 鼠标移出事件
        handleMouseLeave() {
            this.startInterver();
        },
        startInterver() {
            this.data = this.tableData.slice(this.startValue, this.endValue)
            // 预先判断定时器是否清除，存在消除1
            if (this.timerId) {
                clearInterval(this.timerId);
            }
            // 设置定时器2
            this.timerId = setInterval(() => {
                this.data = this.tableData.slice(this.startValue, this.endValue);
                this.startValue++
                this.endValue++
                if (this.endValue > this.tableData.length) {
                    this.startValue = 0
                    this.endValue = 5
                }
            }, 2000);
        },
    },
    mounted() {
        this.startInterver()
    },
};
</script>
<style scoped>
.high-tech-table-container {
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    /* background: linear-gradient(135deg, #0f0c29, #302b63, #24243e); */
    /* 深蓝色渐变背景 */
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    font-family: 'Orbitron', sans-serif;
    /* 科技感字体 */
}

.table-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 15px;
    border: 2px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
    backdrop-filter: blur(10px);
}

table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

th {
    background: linear-gradient(135deg, #00d2ff, #3a7bd5);
    /* 表头渐变背景 */
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    /* 字母大写 */
    position: sticky;
    top: 0;
    /* 表头固定在顶部 */
    z-index: 1;
}

tbody tr {
    transition: all 0.3s ease;
}

tbody tr:hover {
    background: rgba(255, 255, 255, 0.1);
    /* 悬浮时背景变亮 */
    transform: scale(1.02);
    /* 悬浮时放大 */
}

/* 滚动条样式 */
.table-wrapper::-webkit-scrollbar {
    width: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
}

.table-wrapper::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #00d2ff, #3a7bd5);
    border-radius: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {

    th,
    td {
        padding: 12px;
        font-size: 14px;
    }
}

@media (max-width: 480px) {

    th,
    td {
        padding: 10px;
        font-size: 12px;
    }
}
</style>